<div class="addon-card">
  <div *ngIf="!editMode" class="addon-card__meta">
    <div class="meta-row">
      <span class="meta-label">{{ "addons.links.name" | translate }}</span>
      <span class="meta-value">{{ link.name }}</span>
    </div>
    <div class="meta-row">
      <span class="meta-label">{{ "addons.links.url" | translate }}</span>
      <span class="meta-value">{{ link.url }}</span>
    </div>
    <div class="meta-row">
      <span class="meta-label">{{ "addons.links.text" | translate }}</span>
      <span class="meta-value">{{ link.text }}</span>
    </div>
    <div class="meta-row" *ngIf="link.modifiedAt">
      <span class="meta-label">{{ "modifiedAt" | translate }}</span>
      <span class="meta-value">{{
        link.modifiedAt | localizedDate: "medium"
      }}</span>
    </div>
    <div class="meta-row">
      <span class="meta-label">{{ "addons.usage.label" | translate }}</span>
      <span class="meta-value" *ngIf="!link.isUsed">{{
        "addons.usage.notUsed" | translate
      }}</span>
      <div class="addon-usage" *ngIf="link.isUsed">
        <span class="meta-value">{{
          "addons.usage.usedInCount"
            | translate: { count: (link.usedInSignatures?.length || 0) }
        }}</span>
        <ul class="addon-usage__list" *ngIf="link.usedInSignatures?.length">
          <li *ngFor="let signature of link.usedInSignatures">
            <a [routerLink]="['/signatures', signature.templateId, 'edit']">{{
              signature.name
            }}</a>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <form
    [formGroup]="form"
    class="addon-card__form"
    (ngSubmit)="changeLink()"
    *ngIf="editMode"
  >
    <div class="meta-row" *ngIf="link.modifiedAt">
      <span class="meta-label">{{ "modifiedAt" | translate }}</span>
      <span class="meta-value">{{
        link.modifiedAt | localizedDate: "medium"
      }}</span>
    </div>
    <mat-form-field appearance="outline">
      <mat-label>{{ "addons.links.name" | translate }}</mat-label>
      <input
        matInput
        formControlName="name"
        type="text"
        [errorStateMatcher]="errorStateMatcher"
      />
      <mat-error *ngIf="form.hasError('required', ['name'])">{{
        "fieldRequired" | translate
      }}</mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>{{ "addons.links.url" | translate }}</mat-label>
      <input
        matInput
        formControlName="url"
        type="text"
        [errorStateMatcher]="errorStateMatcher"
      />
      <mat-error *ngIf="form.hasError('required', ['url'])">{{
        "fieldRequired" | translate
      }}</mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>{{ "addons.links.text" | translate }}</mat-label>
      <input
        matInput
        formControlName="text"
        type="text"
        [errorStateMatcher]="errorStateMatcher"
      />
      <mat-error *ngIf="form.hasError('required', ['text'])">{{
        "fieldRequired" | translate
      }}</mat-error>
    </mat-form-field>
  </form>

  <div class="addon-card__actions">
    <button
      type="button"
      class="action-btn"
      *ngIf="editMode"
      (click)="cancelEditLink()"
      [attr.aria-label]="'cancel' | translate"
    >
      <mat-icon>cancel</mat-icon>
      {{ "cancel" | translate }}
    </button>
    <button
      type="button"
      class="action-btn"
      *ngIf="editMode"
      (click)="changeLink()"
      [attr.aria-label]="'save' | translate"
    >
      <mat-icon>save</mat-icon>
      {{ "save" | translate }}
    </button>
    <button
      type="button"
      class="action-btn"
      *ngIf="!editMode"
      (click)="changeEditMode()"
      [attr.aria-label]="'edit' | translate"
    >
      <mat-icon>edit</mat-icon>
      {{ "edit" | translate }}
    </button>
    <button
      type="button"
      class="action-btn action-btn--danger"
      *ngIf="!editMode && !link.isUsed"
      (click)="removeLink(link.addonId)"
      [attr.aria-label]="'delete' | translate"
    >
      <mat-icon>delete_outline</mat-icon>
      {{ "delete" | translate }}
    </button>
  </div>
</div>
